import { render } from "./AuditReport.vue?vue&type=template&id=39e1fbe8"
import script from "./AuditReport.vue?vue&type=script&lang=js"
export * from "./AuditReport.vue?vue&type=script&lang=js"
script.render = render

export default script